<template>
  <loading :active="allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <Dialog
    v-model:visible="showModal"
    class="w-1/2 bg-white shadow rounded-xl"
    :modal="true"
  >
    <template #header>
      <div class="w-full text-gray-900 font-semibold">{{lang['components']['Dialog']['DisclaimerDialog']['title_text']}}</div>
    </template>
    <div class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pb-8 rounded-bl-lg rounded-br-lg">
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_01']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_02_01']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_02_02']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_03']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_04']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_05']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_06_01']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_06_02']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_07']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_08']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_09']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_10']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_11']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_12']"></p>
      <p v-html="lang['components']['Dialog']['DisclaimerDialog']['paragraph_13']"></p>
    </div>
    <template #footer>
      <div class="w-full text-right pt-4 border-t border-gray-400">
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-2 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2" @click="doActive">{{lang['components']['Dialog']['DisclaimerDialog']['close_button']}}</button>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import RadioButton from 'primevue/radiobutton';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "ActivePlenItemDialog",
  components: {
    Dialog,
    RadioButton,
    DataTable,
    Column,
    Loading
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    userStatus:{
      type: String,
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      itemSelect: null,
      allPageLoading: false,
    }
  },
  methods: {
    doActive(){
      this.showModal = false
    }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function(value) {
        this.$emit("update:show", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep() {
  .p-datatable {
    tr button {
      opacity: 0;
    }

    tr {
      &:hover {
        button {
          opacity: 1;
        }
      }
    }
  }

  .p-datatable .p-datatable-thead > tr > th {
    background: transparent !important;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(107, 114, 128, var(--tw-border-opacity));
  }

  .p-datatable .p-datatable-tbody > tr > td {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(107, 114, 128, var(--tw-border-opacity));
  }

  .p-datatable .p-datatable-tbody > tr:hover {
    --tw-bg-opacity: 1;
    background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
  }
}
</style>
